import {REG} from "/@lib@/commons/registry.js";
import {Wsp, WspSrv} from "/@lib@/wsp/wsp.js";
import {StylerSrcImportSkin} from "/@back@/styler/widgets/stylerSrcDrawer.js";
import {JSkinEntry, JSkinPackInstalled, JWspOptionDef, JWspTypeDef, PackSrv, WSPPACK} from "/@lib@/wsp/pack.js";
import {IO} from "/@lib@/commons/io/io.js";
import {Action4SrcPointer} from "/@back@/wsp/widgets/wed/ptrItem.js";
import {srcRef} from "/@lib@/wsp/src.js";

/** Initialisation du contexte du registre de l'atelier */
REG.reg.addToList("actions:wsp:wed:ptr-item", StylerSrcImportSkin.SINGLETON.getId(), 1, new Action4SrcPointer(StylerSrcImportSkin.SINGLETON));
REG.reg.addToList('srcFields:longDesc', 'itAttr_skClass', 1, 'itAttr_skClass');
REG.reg.addToList('srcFields:longDesc', 'itAttr_skClassStl', 1, 'itAttr_skClassStl');

//REG.reg.addToList('srcFields:longDesc', 'itAttrList_skModelsTitles', 1, 'itAttrList_skModelsTitles');


/**
 * SkinClassStl
 */

export class SkinClassStl {

	constructor(protected config: OSkinClassStlConfig) {}

	get code(): string {return this.config.code}

	get name(): string {return this.config.name}

	get class(): string {return this.config.skinClass}

	get ownerWspTypeStlName(): string {return this.config?.ownerWspTypeStlName}

	public skinClass(wsp: Wsp): SkinClass {
		return STYLER.getSkinClass(wsp, this.config.skinClass);
	}

}

/** Configuration d'un skinClassStl. */
interface OSkinClassStlConfig {
	/** Identifiant unique du skinClassStl dans REG.reg */
	code: string

	/** Nom affichable du skinClassStl */
	name: string

	/** Référence à la skinClassStl associé à ce skin */
	skinClass: string

	/** Nae du modèle styler d'appartenance */
	ownerWspTypeStlName: string

}


/**
 * SkinClass
 */
export class SkinClass {
	constructor(protected config: OSkinClassConfig) {}

	get class(): string {return this.config?.class}

	get name(): string {return this.config?.name || this.class}

	get sgn(): string {return this.config?.sgn}

	/** Retourne true si le skinClassStl est de type "ODT" */
	static isSkinClassOdt(skinClass: SkinClass): boolean {
		return skinClass?.sgn.match(/.*#odt\b.*/) ? true : false;
	}

	/** Retourne true si le skinClassStl est de type "DOSS" */
	static isSkinClassDoss(skinClass: SkinClass): boolean {
		return skinClass?.sgn.match(/.*#doss\b.*/) ? true : false;
	}

	equals(other: SkinClass) {
		return other && other.class === this.class;
	}

}

interface OSkinClassConfig {
	/** Identifiant unique du skinClassStl dans REG.reg */
	class: string
	/** Nom affichable du skinClassStl */
	name?: string
	/**  */
	sgn: string
}


/**
 * RegisteredSkin
 */
export class RegisteredSkin {
	constructor(protected skin: JSkinEntry, protected cLass: string, protected wspTypeDef: JWspTypeDef | JWspOptionDef) {}

	/** Identifiant unique du skin (pour un même skinClass) */
	get code(): string {return this.skin?.code}

	/** Nom affichable du skin */
	get name(): string {return this.skin?.name || this.code}

	/** SkinClass */
	public skinClass(wsp: Wsp): SkinClass {
		return STYLER.getSkinClass(wsp, this.cLass);
	}

	/** wspTypeDef ou wspOptionDef d'appartenance */
	get owner(): OSkinWspDefOwner {
		return {
			key: this.wspTypeDef?.key,
			isExt: (this.wspTypeDef as JWspOptionDef)?.isOption,
			name: this.wspTypeDef?.title,
			version: this.wspTypeDef?.version,
			lang: this.wspTypeDef?.lang,
		}
	}

	/** Icône du skin
	 * Remarque : WSP.skinSetsIconUrl` non utilisé car tous les skins sont proposés ici, qu'ils soient activés ou pas sur le svc skinSet
	 **/
	public getIconUrl(wspServer: WspSrv): string {
		if (this.wspTypeDef && this.skin.iconPath && this.skin.keyRes)
			return wspServer.config.adminWspUrl.resolve(IO.qs("cdaction", "GetRes", "param", this.skin.keyRes + '~' + this.wspTypeDef.lang + '#' + this.wspTypeDef.version + '#' + this.wspTypeDef.version + "/" + this.skin.iconPath)).url
		else if (this.wspTypeDef && this.skin.iconPath){
			// TODOsc7 : supprimer ce cas. Laissé pour compat asc sc6.0
			return wspServer.config.adminWspUrl.resolve(IO.qs("cdaction", "GetRes", "param", this.wspTypeDef.key + '.ss~' + this.wspTypeDef.lang + '#' + this.wspTypeDef.version + '#' + this.wspTypeDef.version + "/" + this.skin.iconPath)).url
		}
		//else return "/@skin@/styler/actions/skinEntry.svg";
	}

	public getSrcUrl(wspServer: WspSrv): string {
		if(this.wspTypeDef && this.skin.keyRes){
			return wspServer.config.adminWspUrl.resolve(IO.qs("cdaction", "GetRes", "param", this.skin.keyRes + '~' + this.wspTypeDef.lang + '#' + this.wspTypeDef.version + '#' + this.wspTypeDef.version + "/" + this.skin.path)).url;
		}else if(this.wspTypeDef){
			// TODOsc7 : supprimer ce cas. Laissé pour compat asc sc6.0
			return wspServer.config.adminWspUrl.resolve(IO.qs("cdaction", "GetRes", "param", this.wspTypeDef.key + '.ss~' + this.wspTypeDef.lang + '#' + this.wspTypeDef.version + '#' + this.wspTypeDef.version + "/" + this.skin.path)).url;
		}
	}

}

interface OSkinWspDefOwner {
	key: string
	name: string
	version?: string
	lang: string
	isExt?: boolean
}

/** skinClassSstyler */
export const LIST_SKIN_CLASSES_STL = "styler:skinclasses:stl";
/** skinClass */
export const LIST_SKIN_CLASSES = "styler:skinclasses";

/**
 *
 */
export namespace STYLER {

	/** Retourne la liste complète des skinClassesStyler déclarés dans le contexte courant (modèle ET extension) */
	export function getSkinClassesStl(wsp: Wsp): Dict<SkinClassStl> {
		return wsp.reg.getListAsMap(LIST_SKIN_CLASSES_STL);
	}

	/** Retourne un skinClasseStyler donné si existant */
	export function getSkinClassStl(wsp: Wsp, skinClassStlKey: string): SkinClassStl | undefined {
		const skinCLassesStylerDef: Dict<SkinClassStl> = wsp.reg.getListAsMap(LIST_SKIN_CLASSES_STL);
		return skinCLassesStylerDef ? skinCLassesStylerDef[skinClassStlKey] : null;
	}

	/** Retourne un skinClass donné si existant */
	export function getSkinClass(wsp: Wsp, skinClassKey: string): SkinClass | undefined {
		const skinCLassesDef: Dict<SkinClass> = wsp.reg.getListAsMap(LIST_SKIN_CLASSES);
		return skinCLassesDef ? skinCLassesDef[skinClassKey] : null;
	}

	/** Retourne la liste des skins déclarés dans les différents packs installés pour un skinClass donné */
	export async function getRegisteredSkins(wsp: Wsp, skinClasses: string[]): Promise<Set<RegisteredSkin>> {
		const list = await WSPPACK.listWspTypesDef(wsp.reg.env.universe.packServer, skinClasses, true);
		const result: Set<RegisteredSkin> = new Set();
		if (list)
			list.forEach((wspTypeDef) => {
				if (wspTypeDef.skinClasses) wspTypeDef.skinClasses.forEach((skinCLassDef) => {
					if (!skinClasses || skinClasses.indexOf(skinCLassDef.class) > -1) {
						const skins = skinCLassDef.skins;
						if (skins)
							skins.forEach((skin) => {
								result.add(new RegisteredSkin(skin, skinCLassDef.class, wspTypeDef));
							});
					}
				});
			});
		return result;
	}

	/**
	 * SCENARIstyler : Liste tous les skinSets installés dans cet univers compatibles avec ce WspType
	 * @see eu.scenari.wsp.service.skinpack.SvcSkinPackDialog.CDACTION_ListSkinsForSkinClass
	 * @param skinClass
	 * @param keyWspType : key du wspType (racine, pas d'un WspOption)
	 * @param langWspType : langue du wspType
	 * @param versionWspType : version du wspType
	 */
	export function listSkinsFromSkinsPacks(packServer: PackSrv, skinClass: string, lang?: string): Promise<JSkinPackSkin[]> {
		return packServer.config.skinPackUrl.fetchJson(IO.qs("cdaction", "ListSkinsForSkinClass", "param", skinClass, "lang", lang));
	}

	export interface JSkinPackSkin {
		code: string
		title: string
	}

	/**
	 * SCENARIstyler : télécharge le skin d'un générateur
	 * @see eu.scenari.wsp.service.skinpack.SvcSkinPackDialog.CDACTION_GetSkin
	 * @param genCode : code du generator
	 * @param skinPackId :
	 * @param keyWspType : key du wspType (racine, pas d'un WspOption)
	 * @param langWspType : langue du wspType
	 * @param versionWspType : version du wspType
	 */
	export async function getSkin(packServer: PackSrv, skinPackId: string, skinCLass: string, lang?: string): Promise<Blob> {
		return packServer.config.skinPackUrl.fetchBlob(IO.qs("cdaction", "GetSkin", "param", skinCLass, "skinPackId", skinPackId, "lang", lang));
	}

	export function getSkinUrl(packServer: PackSrv, skinPackId: string, skinCLass: string, lang?: string): string {
		return packServer.config.skinPackUrl.resolve(IO.qs("cdaction", "GetSkin", "param", skinCLass, "skinPackId", skinPackId, "lang", lang)).url;
	}


	/**
	 * Génération
	 * @param wsp
	 * @param uiContext
	 * @param srcRef
	 * @param codeGenStack
	 * @param props
	 * @param customFullUriDest : spécification libre d'une fullUri de destination (usage : styler)
	 * @param targets : code des univers cibles (autorisés dans le svc wspGen)
	 * 	ATTENTION : nécessite des habilitations dédiées
	 */
	export async function installGenAsSkinpack(wsp: Wsp, uiContext: HTMLElement, srcRef: srcRef, codeGenStack: string, props: Jsonisable, customFullUriDest?: string, lang?: string, targets?:string[]): Promise<{universe:string, skinPack:JSkinPackInstalled}[]> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const optionalParams = [];
		if(targets)
			optionalParams.push("targets", targets);
		return wsp.wspServer.config.wspGenUrl.fetchJson<{universe:string, skinPack:JSkinPackInstalled}[]>(IO.qs("cdaction", "InstallGenAsSkinPack", "param", wsp.code, "refUri", srcRef, "codeGenStack", codeGenStack, "lang", lang, ...optionalParams), {method: "POST"});
	}

}


